var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _circle, _rect, _rect2, _ellipse3, _ellipse4, _path7, _circle2, _circle3, _path8, _ellipse5, _ellipse6, _circle4, _rect3, _rect4, _ellipse7, _ellipse8, _path9, _circle5, _circle6, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawDecideReIxfw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 649.67538,
    height: 226.1298,
    viewBox: "0 0 649.67538 226.1298",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bcc0edba-f0dd-423b-bdfc-f2fa10ec70b3-337",
    "data-name": "Path 680",
    d: "M363.08335,336.9351a3.78766,3.78766,0,0,0,0,7.57532H439.9178a3.78766,3.78766,0,1,0,0-7.57532Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fa56b25f-6ad1-4bb0-b587-f288aecf2229-338",
    "data-name": "Path 681",
    d: "M363.08335,359.25074a3.78767,3.78767,0,0,0,0,7.57533H439.9178a3.78767,3.78767,0,0,0,0-7.57533Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b413f49f-a7ee-4528-83fd-849b3d17d98f-339",
    "data-name": "Path 682",
    d: "M401.50117,430.02472a23.84091,23.84091,0,1,1,23.84091-23.842h0A23.86874,23.86874,0,0,1,401.50117,430.02472Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#e4e4e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ba255611-006f-40c2-b981-3cbda4cfa311-340",
    "data-name": "Path 680",
    d: "M760.08335,336.9351a3.78766,3.78766,0,1,0,0,7.57532H836.9178a3.78766,3.78766,0,0,0,0-7.57532Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "f7616677-88a5-4e4e-be2c-5696cf4c3e42-341",
    "data-name": "Path 681",
    d: "M760.08335,359.25074a3.78767,3.78767,0,0,0,0,7.57533H836.9178a3.78767,3.78767,0,0,0,0-7.57533Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b0ec98cc-856e-42d0-b3d1-ea9b3df6bb16-342",
    "data-name": "Path 682",
    d: "M798.50117,430.02472a23.84091,23.84091,0,1,1,23.84091-23.842h0A23.86874,23.86874,0,0,1,798.50117,430.02472Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#e4e4e4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 484.90215,
    cy: 475.49165,
    rx: 7.19508,
    ry: 22.91937,
    transform: "translate(-427.67489 372.91709) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.28661,
    cy: 504.7203,
    rx: 7.19508,
    ry: 22.91937,
    transform: "translate(-462.64755 156.53075) rotate(-39.93837)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261.3695,
    cy: 159.8261,
    r: 45.83867,
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 266.84564,
    y: 195.8006,
    width: 13.92567,
    height: 24.95017,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 238.9943,
    y: 195.8006,
    width: 13.92567,
    height: 24.95017,
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.16657,
    cy: 221.04089,
    rx: 11.60475,
    ry: 4.35179,
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.31523,
    cy: 220.46068,
    rx: 11.60475,
    ry: 4.35179,
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M522.13878,439.14059c4.093-16.48357,22.16034-26.18381,40.35452-21.66607s29.6254,21.54274,25.53236,38.02632-17.67239,16.53678-35.86657,12.019S518.04574,455.6242,522.13878,439.14059Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.51656,
    cy: 150.15373,
    r: 15.28261,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.23545,
    cy: 144.67575,
    r: 5.0942,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M539.26587,518.92927a10.18842,10.18842,0,0,1-20.04736,3.64948h0l-.00358-.01969c-1.00237-5.5369,3.27861-7.49624,8.81551-8.49855S538.26356,513.39243,539.26587,518.92927Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 715.09785,
    cy: 475.49165,
    rx: 22.91937,
    ry: 7.19508,
    transform: "translate(-409.9374 15.37692) rotate(-25.37426)",
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 614.71339,
    cy: 504.7203,
    rx: 22.91937,
    ry: 7.19508,
    transform: "translate(-442.05925 315.09586) rotate(-50.06163)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.30588,
    cy: 159.8261,
    r: 45.83867,
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 368.90407,
    y: 195.8006,
    width: 13.92567,
    height: 24.95017,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 396.75541,
    y: 195.8006,
    width: 13.92567,
    height: 24.95017,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.50882,
    cy: 221.04089,
    rx: 11.60475,
    ry: 4.35179,
    fill: "#2f2e41"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.36016,
    cy: 220.46068,
    rx: 11.60475,
    ry: 4.35179,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M677.86122,439.14059c-4.093-16.48357-22.16034-26.18381-40.35452-21.66607s-29.6254,21.54274-25.53236,38.02632,17.67239,16.53678,35.86657,12.019S681.95426,455.6242,677.86122,439.14059Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.15882,
    cy: 150.15373,
    r: 15.28261,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.43994,
    cy: 144.67575,
    r: 5.0942,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M660.73413,518.92927a10.18842,10.18842,0,0,0,20.04736,3.64948h0l.00358-.01969c1.00237-5.5369-3.27861-7.49624-8.81551-8.49855S661.73644,513.39243,660.73413,518.92927Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M923.647,563.0649H276.353a1.19069,1.19069,0,0,1,0-2.38137H923.647a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-275.16231 -336.9351)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDecideReIxfw);
export default __webpack_public_path__ + "static/media/undraw_decide_re_ixfw.96e3733549a4977d438f7c9998de0900.svg";
export { ForwardRef as ReactComponent };